export default "__VITE_ASSET__B5TBda_E__"